import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-bottom-image-modal',
  standalone: true,
  templateUrl: './bottom-image-modal.component.html',
  styleUrls: ['./bottom-image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomImageModalComponent {
  @Input() btnText: string;
  @Input() text: string;
  @Input() img: string;
  @Input() altText: string;

  constructor(public bsModalRef: BsModalRef) {}

  onSelect(): void {
    this.bsModalRef.hide();
  }
}
